import React, { useRef, useEffect, useState } from "react";
import { logResponse } from "../utils/logger";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchReceiveInquiry, fetchGetCustomer } from "../api";
import SubmitButton from "../components/SubmitButton";
import iconContact from "../assets/img/icon_contact.svg";

const Contact = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const initialType = params.get("type") || "";
  const initialContent = params.get("content") || "";

  const formRef = useRef();
  const isSubmittingRef = useRef(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [customer, setCustomer] = useState(null);

  useEffect(() => {
    const access_token = localStorage.getItem("access_token");
    if (!access_token) return;

    fetchGetCustomer(access_token).then((res) => {
      setCustomer(res);
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setIsSubmitting(true);
    setSuccessMessage("");
    setErrorMessage("");

    const formData = new FormData(formRef.current);
    formData.set("access_token", localStorage.getItem("access_token") || "");
    formData.set("customer_name", customer?.customer_name || "");
    formData.set("phone_number", customer?.phone_number_1 || "");

    const access_token = formData.get("access_token");
    const data = Object.fromEntries(formData.entries());

    if (!access_token || !data.inquiry_type || !data.inquiry_content) {
      setErrorMessage("必須項目が不足しています。内容をご確認ください。");
      isSubmittingRef.current = false;
      setIsSubmitting(false);
      return;
    }

    try {
      const res = await fetchReceiveInquiry(access_token, data);
      logResponse("token:", access_token);
      logResponse("req:", data);
      logResponse("res:", res);

      if (res?.message_id) {
        navigate("/contact-thanks");
        return;
      } else {
        setErrorMessage("送信に失敗しました。時間を置いて再度お試しください。");
      }
    } catch (err) {
      console.error("送信エラー:", err);
      setErrorMessage("通信エラーが発生しました。時間を置いて再度お試しください。");
    } finally {
      isSubmittingRef.current = false;
      setIsSubmitting(false);
    }
  };

  return (
    <section className="section email-section">
      <h2 className="section-title">
        <i>
          <img src={iconContact} alt="" />
        </i>
        お問い合わせ
      </h2>

      <div className="group-wrapper">
        <div className="form-group">
          <form ref={formRef} onSubmit={handleSubmit}>
            <p className="explain">
              通常のお問い合わせのほか、解約や住所・連絡先の変更はこちらからご連絡ください。
            </p>

            <label>
              <select name="inquiry_type" defaultValue={initialType} className="ml0 mr0">
                <option value="">お問い合わせ内容を選択</option>
                <option value="01.商品について">01.商品について</option>
                <option value="02.ホームページについて">02.ホームページについて</option>
                <option value="03.その他のご質問">03.その他のご質問</option>
                <option value="04.お届け内容の変更">04.お届け内容の変更</option>
              </select>
            </label>

            <label>
              <textarea
                name="inquiry_content"
                placeholder="お問い合わせ内容を入力してください"
                defaultValue={initialContent}
              ></textarea>
            </label>

            {errorMessage && (
              <div className="error-message mt20" style={{ color: "red", fontWeight: "bold", marginBottom: "1em" }}>
                {errorMessage}
              </div>
            )}

            {successMessage && (
              <div className="success-message mt20" style={{ color: "green", fontWeight: "bold", marginBottom: "1em" }}>
                {successMessage}
              </div>
            )}

            <div className="btn-green mb0">
              <SubmitButton
                isSubmitting={isSubmitting}
                label="送信"
                className="btn-green"
                wrap={false}
              />
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
